// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
// @ts-ignore-next-line 7016
import { NotificationManager as Notification } from 'react-notifications';
export default Notification;
